import { SET_BULK_FORM_HAS_ERROR } from "constants-lib/actionTypes"

export const setOaklandBulkFormHasError = (data) => (dispatch) =>
  dispatch({
    type: SET_BULK_FORM_HAS_ERROR,
    payload: data,
  })
